<template>
<div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <button type="button" class="btn btn-outline-secondary">
          <i style="color:brown" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
          <strong style="color:blue"> RICERCA PER </strong>
        </button>
        <button type="button" class="btn btn-info dropdown-toggle dropdown-toggle-split rounded" data-toggle="dropdown" aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div  class="dropdown-menu rounded">
        <a  @click="setSearchInput(0)" class="dropdown-item" href="#">
            <!-- <i style="color:rgb(203, 15, 15);font-size: 18px;" class="fas fa-tag mr-2" aria-hidden="true"></i>-->
            <strong >CODICE PRODOTTO FORNITORE</strong></a>
            <a  @click="setSearchInput(1)" class="dropdown-item" href="#">
            <!--<i style="color:rgb(4, 82, 52);font-size: 18px;" class="fas fa-barcode mr-2" aria-hidden="true"></i>-->
            <strong>CODICE A BARRE GESTIONALE</strong></a>
            <a  @click="setSearchInput(2)" class="dropdown-item" href="#">
            <!--<i style="color:crimson;font-size: 18px;" class="fas fa-barcode mr-2" aria-hidden="true"></i>-->
            <strong>CODICE A BARRE FORNITORE</strong></a>
            <a  @click="setSearchInput(3)" class="dropdown-item" href="#">
            <!--<i style="color:black;font-size: 18px;" class="fas fa-hashtag mr-2" aria-hidden="true"></i>-->
            <strong>ID PRODOTTO</strong></a>                                
        </div>
      </div>                
      <input @input="setData($event.target.value,input.id)" autocomplete="off" :type="input.type" required v-model="input.search"  ref="inputSearch" id="inputSearch" class="form-control" aria-label="Text input with segmented dropdown button" :placeholder="input.placeholder">                            
    </div>

</div>
</template>

<script>


import { mapGetters }      from 'vuex';

export default {
   props : ['inputId'],


  components: {},
  data() {
    return {

      input                      : 
      {
          type                   : 'text',
          err                    : false,
          id                     : 0,
          placeholder            : 'CODICE PRODOTTO FORNITORE',
          search                 : '',
      },
      
    };
  },
  computed:{
    ...mapGetters(['storeId','company']) , 
  },
    directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        
        
        el.focus();
      }
    }
  },
  mounted :function() {
 
  },
  created : function()
  {
    this.$nextTick(() => {

          if(this.inputId)
          {
            this.input.id = this.inputId
            this.setSearchInput(this.inputId)
            console.log('InputId',this.inputId)
          }
          this.$refs.inputSearch.focus()
          
         
      })

    
  },
  methods: 
  {
    setData(data,id)    
    {      
      this.$emit('update',data.replace(/%/g,"") ,id)      
    },
    setSearchInput(inputId) 
   {
      if(inputId==0)
      {
        this.input.placeholder = 'CODICE PRODOTTO FORNITORE'
        this.input.type = 'text'
      }
      else if(inputId == 1)
      {
        this.input.placeholder = 'CODICE A BARRE GESTIONALE'
        this.input.type = 'number'
      }
      else if(inputId == 2)
      {
        this.input.placeholder = 'CODICE A BARRE FORNITORE'
        this.input.type = 'number'
      }
      else
      {
        this.input.placeholder = 'ID PRODOTTO'
        this.input.type = 'number'
      }
      this.input.id = inputId
      this.input.search = ''
      this.$refs.inputSearch.focus()

   },
  }

}
</script>
<style scoped>

::placeholder {
  font-weight : bold;
  color   : rgb(60, 122, 238);
  opacity : 1; /* Firefox */
}
</style>


